import React, {useContext} from 'react'
import { Outlet } from 'react-router-dom';
import UserContext from '../../contexts/UserContext';
import { CircularProgress} from '@mui/material';
import Login from '../Login';

const useAuth = () => {
    const user = useContext(UserContext);

    user.checkToken();

    return user.isAuth;
}

const ProtectedRoutes = () =>{

    const isAuth = useAuth();    

    if (isAuth === undefined) {
        return <CircularProgress
            color="secondary"
        />;
    }

    return isAuth ? <Outlet /> : <Login />

}
export default ProtectedRoutes;